import React from 'react';

const VerticalPump9Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 55.18 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	
		<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="35.9797" y1="4.8418" x2="35.9797" y2="18.5811" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} stroke={`${startColor}`} strokeWidth="0.25" d="M31.983,93.919l-0.676,13.739h9.346V93.919H31.983z" />
	
		<linearGradient id={`${uid}_3`} gradientUnits="userSpaceOnUse" x1="43.1877" y1="0.4512" x2="43.1877" y2="22.9727" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_3)`} stroke={`${startColor}`} strokeWidth="0.25" d="M44.032,89.527h-1.689v22.521h1.689V89.527z" />
	
		<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="41.3284" y1="0.4512" x2="41.3284" y2="22.9727" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} stroke={`${startColor}`} strokeWidth="0.25" d="M40.315,89.527h2.027v22.521h-2.027V89.527z" />
	<path fill={`${midColor}`} d="M44.032,111.148h0.45v0.226h-0.45V111.148z" />
	<path fill={`${midColor}`} d="M44.032,107.658h0.45v0.449h-0.45V107.658z" />
	<path fill={`${midColor}`} d="M44.032,104.393h0.45v0.338h-0.45V104.393z" />
	<path fill={`${midColor}`} d="M44.032,101.014h0.45v0.226h-0.45V101.014z" />
	<path fill={`${midColor}`} d="M44.032,97.521h0.45v0.338h-0.45V97.521z" />
	<path fill={`${midColor}`} d="M44.032,90.991h0.45v0.226h-0.45V90.991z" />
	<path fill={`${midColor}`} d="M44.032,94.145h0.45v0.45h-0.45V94.145z" />
	<path fill={`${midColor}`} d="M44.032,111.148h0.45v-0.563h-0.45V111.148z" />
	<path fill={`${midColor}`} d="M44.032,107.658h0.45v-0.227h-0.45V107.658z" />
	<path fill={`${midColor}`} d="M44.032,104.166h0.45v-0.225h-0.45V104.166z" />
	<path fill={`${midColor}`} d="M44.032,101.014h0.45v-0.451h-0.45V101.014z" />
	<path fill={`${midColor}`} d="M44.032,97.521h0.45v-0.449h-0.45V97.521z" />
	<path fill={`${midColor}`} d="M44.032,94.145h0.45v-0.226h-0.45V94.145z" />
	<path fill={`${midColor}`} d="M44.032,90.652h0.45v-0.226h-0.45V90.652z" />
	<path fill={`${midColor}`} d="M40.315,90.428H40.09v0.563h0.225V90.428z" />
	<path fill={`${midColor}`} d="M40.315,93.693H40.09v0.676h0.225V93.693z" />
	<path fill={`${midColor}`} d="M40.315,97.072H40.09v0.787h0.225V97.072z" />
	<path fill={`${midColor}`} d="M40.315,100.563H40.09v0.677h0.225V100.563z" />
	<path fill={`${midColor}`} d="M40.315,103.941H40.09v0.451h0.225V103.941z" />
	<path fill={`${midColor}`} d="M40.315,107.207H40.09v0.676h0.225V107.207z" />
	<path fill={`${midColor}`} d="M40.315,110.586H40.09v0.788h0.225V110.586z" />
	<path fill={`${midColor}`} d="M44.032,90.203h0.45v1.014h-0.45V90.203z" />
	<path fill={`${midColor}`} d="M44.032,93.355h0.45v1.238h-0.45V93.355z" />
	<path fill={`${midColor}`} d="M44.032,96.848h0.45v1.238h-0.45V96.848z" />
	<path fill={`${midColor}`} d="M44.032,100.338h0.45v1.126h-0.45V100.338z" />
	<path fill={`${midColor}`} d="M44.032,103.717h0.45v1.014h-0.45V103.717z" />
	<path fill={`${midColor}`} d="M44.032,107.207h0.45v0.9h-0.45V107.207z" />
	<path fill={`${midColor}`} d="M44.032,110.359h0.45v1.24h-0.45V110.359z" />
</g>
<g id={`${uid}_5`}>
	
		<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="10.0232" y1="4.8418" x2="10.0232" y2="18.5811" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} stroke={`${startColor}`} strokeWidth="0.25" d="M14.077,93.919l0.45,13.739H5.519V93.919H14.077z" />
	
		<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="2.759" y1="0.4512" x2="2.759" y2="22.9727" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} stroke={`${startColor}`} strokeWidth="0.25" d="M1.802,89.527h1.914v22.521H1.802V89.527z" />
	
		<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="4.6174" y1="0.4512" x2="4.6174" y2="22.9727" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} stroke={`${startColor}`} strokeWidth="0.25" d="M5.519,89.527H3.716v22.521h1.802L5.519,89.527L5.519,89.527z   " />
	<path fill={`${midColor}`} d="M1.802,111.148H1.239v0.226h0.563V111.148z" />
	<path fill={`${midColor}`} d="M1.802,107.658H1.239v0.449h0.563V107.658z" />
	<path fill={`${midColor}`} d="M1.802,104.393H1.239v0.338h0.563V104.393z" />
	<path fill={`${midColor}`} d="M1.802,101.014H1.239v0.226h0.563V101.014z" />
	<path fill={`${midColor}`} d="M1.802,97.521H1.239v0.338h0.563V97.521z" />
	<path fill={`${midColor}`} d="M1.802,90.991H1.239v0.226h0.563V90.991z" />
	<path fill={`${midColor}`} d="M1.802,94.145H1.239v0.45h0.563V94.145z" />
	<path fill={`${midColor}`} d="M1.802,111.148H1.239v-0.563h0.563V111.148z" />
	<path fill={`${midColor}`} d="M1.802,107.658H1.239v-0.227h0.563V107.658z" />
	<path fill={`${midColor}`} d="M1.802,104.166H1.239v-0.225h0.563V104.166z" />
	<path fill={`${midColor}`} d="M1.802,101.014H1.239v-0.451h0.563V101.014z" />
	<path fill={`${midColor}`} d="M1.802,97.521H1.239v-0.449h0.563V97.521z" />
	<path fill={`${midColor}`} d="M1.802,94.145H1.239v-0.226h0.563V94.145z" />
	<path fill={`${midColor}`} d="M1.802,90.652H1.239v-0.226h0.563V90.652z" />
	<path fill={`${midColor}`} d="M5.519,90.428h0.45v0.563h-0.45V90.428z" />
	<path fill={`${midColor}`} d="M5.519,93.693h0.45v0.676h-0.45V93.693z" />
	<path fill={`${midColor}`} d="M5.519,97.072h0.45v0.787h-0.45V97.072z" />
	<path fill={`${midColor}`} d="M5.519,100.563h0.45v0.677h-0.45V100.563z" />
	<path fill={`${midColor}`} d="M5.519,103.941h0.45v0.451h-0.45V103.941z" />
	<path fill={`${midColor}`} d="M5.519,107.207h0.45v0.676h-0.45V107.207z" />
	<path fill={`${midColor}`} d="M5.519,110.586h0.45v0.788h-0.45V110.586z" />
	<path fill={`${midColor}`} d="M1.802,90.203H1.239v1.014h0.563V90.203z" />
	<path fill={`${midColor}`} d="M1.802,93.355H1.239v1.238h0.563V93.355z" />
	<path fill={`${midColor}`} d="M1.802,96.848H1.239v1.238h0.563V96.848z" />
	<path fill={`${midColor}`} d="M1.802,100.338H1.239v1.126h0.563V100.338z" />
	<path fill={`${midColor}`} d="M1.802,103.717H1.239v1.014h0.563V103.717z" />
	<path fill={`${midColor}`} d="M1.802,107.207H1.239v0.9h0.563V107.207z" />
	<path fill={`${midColor}`} d="M1.802,110.359H1.239v1.24h0.563V110.359z" />
</g>
<g id={`${uid}_9`}>
	
		<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="12.6125" y1="24.9438" x2="32.9963" y2="24.9438" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} stroke={`${startColor}`} strokeWidth="0.25" d="M28.829,109.348v1.801H16.78v-1.801h-2.026l-2.141-45.384   h20.384l-1.688,45.384H28.829z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M12.613,64.641h1.915l2.027,45.045h-2.027L12.613,64.641z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M33.221,64.641h-1.688l-2.253,45.045h2.027L33.221,64.641z" />
</g>
<g id={`${uid}_11`}>
	<path fill={`${midColor}`} d="M32.77,69.595l1.465,0.226h1.465l1.013,0.226l1.915,0.226l0.676,0.563h0.338l-0.338,0.226l-0.901,0.449   l-1.688,0.227l-2.026,0.338h-2.478l-2.929,0.225H14.752l-1.126-0.225h-2.479v8.333l-0.563,1.239L9.122,82.32l-1.464-0.676   l-0.451-0.563v-9.798l-1.239-0.225v-0.226h0.225l0.789-0.563l1.914-0.226l2.479-0.226l1.464-0.226l1.464,0.226l2.478,0.226   l2.929,0.226h6.419l2.928-0.226h2.253L32.77,69.595z" />
</g>
<g id={`${uid}_12`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M48.199,55.856h4.729v1.689h-4.729V55.856z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M46.735,44.82h2.252l2.365,11.036h-4.617V44.82z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M54.842,51.126l-5.855-6.306l2.365,11.036h2.702L54.842,51.126z" />
	<path fill={`${midColor}`} d="M45.045,45.271h1.688v8.108h-1.688V45.271z" />
</g>
<g id={`${uid}_13`}>
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M49.211,57.545h2.479v8.784l-0.112,0.788l-0.112,1.352l-0.338,1.352l-0.563,1.125   l-0.676,1.128l-0.9,1.014l-0.899,0.899l-1.239,0.789l-1.239,0.787l-1.352,0.677l-1.463,0.676l-1.689,0.563l-1.802,0.563   l-1.802,0.45l-1.914,0.45l-1.014,0.113l-1.015,0.225l-1.127,0.113l0.338-2.93l1.577-0.227l1.464-0.338l1.576-0.338l1.465-0.338   l1.353-0.449l1.351-0.563l1.353-0.563l1.126-0.676l1.127-0.677l1.013-0.788l0.901-0.9l0.676-1.014l0.676-1.014l0.449-1.126   l0.227-1.238l0.111-1.352v-7.319H49.211z" fill={`${midColor}`} />
</g>
<g id={`${uid}_14`}>
	
		<linearGradient id={`${uid}_15`} gradientUnits="userSpaceOnUse" x1="0.3381" y1="78.1533" x2="45.2698" y2="78.1533" gradientTransform="matrix(1 0 0 -1 0 112.5)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_15)`} stroke={`${startColor}`} strokeWidth="0.25" d="M45.27,65.203l-2.702,0.449l-5.181,0.451l-7.094,0.226   l-7.883,0.337l-7.884-0.337l-6.868-0.226l-4.955-0.451l-2.365-0.449V2.027H45.27V65.203" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M22.635,0.338l15.991,0.45l6.644,1.014l-6.644,1.239l-15.991,0.45   L6.982,3.041L0.338,1.802l6.644-1.014L22.635,0.338z" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M45.27,10.135l-6.644,1.013l-15.991,0.451L6.982,11.148l-6.644-1.013" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M45.27,32.996l-6.644,1.013L22.635,34.46L6.982,34.009l-6.644-1.013" />
</g>
<g id={`${uid}_16`}>
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M1.802,4.955L7.883,5.18v3.716L1.802,8.671V4.955z" fill={`${midColor}`} />
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M37.838,5.18l5.969-0.451v3.716l-5.969,0.676V5.18z" fill={`${midColor}`} />
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M19.032,5.743h7.995v3.716h-7.995V5.743z" fill={`${midColor}`} />
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M28.829,5.743l7.319-0.225v3.604L28.829,9.46V5.743z" fill={`${midColor}`} />
	<path stroke={`${startColor}`} strokeWidth="0.25" d="M9.91,5.518l7.319,0.225v3.716L9.91,9.122V5.518z" fill={`${midColor}`} />
</g>
    </svg>
  );
};

export default VerticalPump9Icon;
